module.exports = __webpack_public_path__ + "img/handsup-logo-m.90cc8861.png";